import { forwardRef, type Ref } from 'react';
import { type ChipProps } from '@mui/material';
import { StyledChip } from './styled-chip';

export const Chip = forwardRef(
  ({ variant, size, ...rest }: ChipProps, ref: Ref<HTMLDivElement>) => (
    <StyledChip
      ref={ref}
      variant={variant}
      size={variant === 'outlined' && !size ? 'sm' : size}
      {...rest}
    />
  ),
);

Chip.displayName = 'Chip';
